import { render, staticRenderFns } from "./NotificationItemProgramSummary.vue?vue&type=template&id=01b0d7bc&scoped=true&"
import script from "./NotificationItemProgramSummary.vue?vue&type=script&lang=js&"
export * from "./NotificationItemProgramSummary.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemProgramSummary.vue?vue&type=style&index=0&id=01b0d7bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0d7bc",
  null
  
)

export default component.exports